import type { z } from 'zod';
import type {
  getWithdrawalResponseSchema,
  payOverdueResponseSchema,
  withdrawFullAmountResponseSchema,
} from '@/api/paymentProvider/schemas';
import type { ProductName } from '@/constants/ProductNames';

export type RedirectUrls = {
  successfulUrl: string;
  failedUrl: string;
};

export type SEDepositPayload = RedirectUrls & {
  amount: number;
  productName: ProductName;
};

export type UKDepositPayload = {
  amount: number;
  productName: ProductName;
};

export type SEPayOverduePayload = RedirectUrls & {
  amount: number;
};

export type UKPayOverduePayload = {
  amount: number;
};

export type PayOverdueResponse = z.infer<typeof payOverdueResponseSchema>;

export type PendingTransactionResponse = {
  pendingTransaction: boolean;
  delayed: boolean;
  type: string;
};

export const DepositTypes = {
  PAY_EXTRA: 'PAY_EXTRA',
  OVERDUE: 'OVERDUE',
  COMPLETE_LOAN: 'COMPLETE_LOAN',
} as const;

export type DepositType = (typeof DepositTypes)[keyof typeof DepositTypes];

export type WithdrawResponse = {
  transactionId: string;
};

export type GetWithdrawalResponse = z.infer<typeof getWithdrawalResponseSchema>;

export type WithdrawFullAmountResponse = z.infer<typeof withdrawFullAmountResponseSchema>;
